<script>
import Panel from '@phoenix/mixins/components/common/Panel';
import PanelCloseButton from '@maison/components/common/PanelCloseButton.vue';

export default {
  components: { PanelCloseButton },
  mixins: [Panel],

  props: {
    openFrom: {
      type: String,
      default: 'default',
      validator: (value) => ['default', 'end', 'bottom', 'top'].includes(value),
    },
    fullscreen: {
      type: Boolean,
      default: false,
    },
    shouldDisplayHeader: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    _headerClasses() {
      return ['dialog__header', ...this.headerClasses];
    },

    _classes() {
      return [
        'panel',
        'dialog',
        {
          [`panel--open-from-${this.openFrom}`]: this.openFrom !== 'default',
          'panel--fullscreen': this.fullscreen,
        },
        ...this.classes,
      ];
    },

    _footerClasses() {
      return ['panel__footer', { 'panel__footer--bordered': this.footerBordered }];
    },
  },
};
</script>

<template>
  <div :id="id" :class="_classes" aria-hidden="true">
    <div class="panel__overlay" :data-panel-close="id"></div>

    <div class="box box--solid panel__body">
      <header v-if="shouldDisplayHeader" :class="_headerClasses">
        <div class="dialog__header-title title-caption uppercase" aria-level="1">
          {{ title }}
        </div>

        <panel-close-button :panel-id="id" />
      </header>

      <div :class="_contentClasses">
        <slot name="content" />
      </div>

      <footer v-if="hasFooterSlot" :class="_footerClasses">
        <slot name="footer" />
      </footer>
    </div>
  </div>
</template>
